<template>
  <div class="AboutUS">

    <div class="swiper-container AboutUSswiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div class="introduce">
            <div class="title_box">公司概况</div>
            <div class="introduce_box">
              <div class="img_box">
                <img src="../../static/images/img/guanyuwomen/jieshao.png"
                     alt="">
              </div>
              <div class="text_box">
                <div class="title">
                  公司简介
                </div>
                <div class="text">
                  <p>
                    河南零一零二信息技术有限公司是专业的定制开发服务公司，自成立以来，秉承全心全意，合作共赢的经营理念，着力打造集战略咨询、平台技术和专业服务为一体的软件企业。为企业量身定制ERP系统、OA系统、安卓/IOS、软件定制开发、等相关软件开发服务，行业涉及企事业单位、景区旅游、地产金融、餐饮酒店、食品日化、工业制造、建筑建材、家居家电、机械电子、医药卫生、机构教育、环保园林、交通运输、物流商贸、时尚服饰等多个领域，已为上百家企业服务，得到了客户的尊重与认可。
                  </p>
                  <p style="margin:0.1042rem 0px">
                    我们信仰并一直坚持，为客户打造真正有价值的互联网平台。公司以人为本，重视对人才的培养与使用，多年来，我们培养了大量的行业性人才，实现员工与企业的共同成长。公司内部注重劳逸结合，在工作之余组织各种丰富的文艺娱乐活动，让员工拥有“成就感”、“归属感”。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第三屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div class="US_style">
            <div class="title_box">公司风采展示</div>
            <div class="US_style_box">
              <div class="left_prev"
                   @click="USprevWay"></div>
              <div class="left_next"
                   @click="USnextWay"></div>
              <div class="swiper-container USswiper"
                   style="width: 100%;height: 100%;overflow: hidden;">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       style="width: 100%;height: 100%;">
                    <div class="style_ul">
                      <div class="img_box1">
                        <img src="../../static/images/img/guanyuwomen/fengcai1.png"
                             alt="">
                      </div>
                      <div class="img_box2">
                        <div> <img src="../../static/images/img/guanyuwomen/fengcai2.png"
                               alt=""></div>
                        <p>
                          <img src="../../static/images/img/guanyuwomen/fengcai3.png"
                               alt="">
                        </p>
                      </div>
                      <div class="img_box3">
                        <img src="../../static/images/img/guanyuwomen/fengcai4.png"
                             alt="">
                      </div>
                      <div class="img_box4">
                        <p>
                          <img src="../../static/images/img/guanyuwomen/fengcai5.png"
                               alt="">
                        </p>
                        <p>
                          <img src="../../static/images/img/guanyuwomen/fengcai6.png"
                               alt="">
                        </p>
                        <p>
                          <img src="../../static/images/img/guanyuwomen/fengcai7.png"
                               alt="">
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第四屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div class="qualifications">
            <div class="title_box">资质荣誉</div>
            <div class="qualifications_box">
              <div class="left_prev"
                   @click="ficationsprevWay"></div>
              <div class="left_next"
                   @click="ficationsnextWay"></div>
              <div class="swiper-container ficationsSwiper"
                   style="width: 100%;height: 100%;overflow: hidden;">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       style="width: 100%;height: 100%;">
                    <div class="qualifications_ul">
                      <div class="img_box"
                           v-for="item,index in 8"
                           :key="index">
                        <img src="../../static/images/img/guanyuwomen/zizhi.png"
                             alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第五屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <el-scrollbar ref="AboutUSscroll"
                        style="height: 100%">
            <div class="cooperation"
                 style="margin-bottom:0.2604rem">
              <div class="title_box">合作伙伴</div>
              <div class="cooperation_box">
                <div class="hezuohuoban_bg">
                  <img src="../../static/images/img/hezuohuoban.png"
                       alt="">
                </div>
              </div>
            </div>
            <Footer></Footer>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Banner from "@/components/banner.vue";
import { mapMutations } from 'vuex';
export default {
  computed: {
    AboutUSPage: {
      get () {
        return this.$store.state.AboutUSPage
      },
      set (value) {
        this.$store.commit('putAboutUSPage', value)
      }
    }
  },
  components: {
    Footer,
    Banner
  },
  watch: {
    AboutUSswiperId: {
      handler (e) {
        if (e == 4) {
          this.AboutUSPage = e
          this.$refs.AboutUSscroll.wrap.scrollTop = 1
          this.AboutUSswiper.disableMousewheelControl()
        }
      }
    },
    AboutUSPage: {
      handler (e) {
        if (e !== this.AboutUSswiperId) {
          this.AboutUSswiper.slideTo(e)
        }
      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.AboutUSscroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.AboutUSswiper.slidePrev()
        _this.AboutUSswiper.enableMousewheelControl()
      }
    }
    this.AboutUSswiper = new Swiper('.AboutUSswiper', {
      initialSlide: _this.AboutUSswiperId,
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 1000, // 每次切换时长
      // scrollbar: '.swiper-scrollbar', // 滚动条
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.AboutUSswiperId = swiper.activeIndex
      }
    })
    this.USswiper = new Swiper('.USswiper', {
      loop: true,
      autoplay: false,
      speed: 700,
    })
    this.ficationsSwiper = new Swiper('.ficationsSwiper', {
      loop: true,
      autoplay: 2000,
      speed: 900,
    })
  },
  data () {
    return {
      scrollTop: 0,
      AboutUSswiper: '',
      AboutUSswiperId: '',
      USswiper: '',
      ficationsSwiper: '',
    }
  },
  methods: {
    USprevWay () {
      this.USswiper.slideNext()
    },
    USnextWay () {
      this.USswiper.slidePrev()
    },
    ficationsprevWay () {
      this.ficationsSwiper.slidePrev()
    },
    ficationsnextWay () {
      this.ficationsSwiper.slideNext()
    }
  }
}
</script>

<style lang="scss" scoped>
.AboutUS {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.153rem;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .introduce {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .title_box {
      margin-top: 0.4948rem;
      color: #000;
    }
    .introduce_box {
      margin: 0 1.875rem;
      position: relative;
      min-height: 3.1198rem;

      margin-top: 0.1063rem;
      .img_box {
        position: absolute;
        top: 50%;
        left: 0rem;
        transform: translateY(-50%);
        width: 2.5938rem;
        height: 2.5938rem;
        background-color: skyblue;
      }
      .text_box {
        padding: 0.1563rem 0.2083rem 0.1563rem 0px;
        padding-left: 1.9925rem;
        margin-left: 0.7813rem;
        border: 0.0104rem solid #e71623;
        min-height: 3.1198rem;
        .title {
          font-size: 0.1563rem;
          font-family: MicrosoftYaHei;
          line-height: 0.276rem;
          color: #000000;
          letter-spacing: 0.0104rem;
          opacity: 1;
          display: inline-block;
          position: relative;
        }
        .title::before {
          content: "";
          width: 100%;
          height: 0.0625rem;
          background: #ff6100;
          opacity: 0.25;
          border-radius: 0.0313rem;
          position: absolute;
          bottom: 0.0321rem;
          left: 0rem;
        }
        .title::after {
          content: "Company profile";
          position: absolute;
          bottom: -0.1481rem;
          left: 50%;
          transform: translateX(-50%);
          width: 0.8354rem;
          font-size: 0.0729rem;
          font-family: AdobeHeitiStd-Regular;
          line-height: 0.276rem;
          color: #ff610025;
          letter-spacing: 0.0104rem;
          opacity: 1;
        }
        .text {
          margin-top: 0.1042rem;
          text-align: left;
          font-size: 0.0833rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1771rem;
          color: #666666;
          letter-spacing: 0.0052rem;
          opacity: 1;
          text-align: justify;
          text-justify: inter-word;
          text-indent: 0.1666rem;
        }
      }
    }
  }
  .US_style {
    width: 100vw;
    height: 100vh;
    .title_box {
      margin-top: 0.4948rem;
      color: #000;
    }
    .US_style_box {
      position: relative;
      padding: 0.0542rem 1.875rem;
      color: #000;
      height: 3.6042rem;
      .left_prev {
        position: absolute;
        left: 0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 43% center;
        background-image: url("../../static/images/icon/left_prev.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_prev:hover {
        background-color: #00000080;
      }
      .left_next {
        position: absolute;
        right: 0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 57% center;
        background-image: url("../../static/images/icon/left_next.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_next:hover {
        background-color: #00000080;
      }
      .style_ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .img_box1 {
          width: 3.0375rem;
          height: 1.9188rem;
          background-color: pink;
        }
        .img_box2 {
          width: 1.3625rem;
          height: 1.9188rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          div {
            height: 47%;
            background-color: skyblue;
          }
          p {
            height: 47%;
            background-color: skyblue;
          }
        }
        .img_box3 {
          width: 1.5625rem;
          height: 1.9188rem;
          background-color: yellow;
        }
        .img_box4 {
          width: 100%;
          height: 1.6042rem;
          display: flex;
          justify-content: space-between;
          margin-top: 0.1042rem;
          p {
            width: 32%;
            background-color: deeppink;
          }
        }
      }
    }
  }
  .qualifications {
    .title_box {
      color: #000;
      margin-top: 0.4948rem;
    }
    .qualifications_box {
      position: relative;
      padding: 0.0542rem 1.875rem;
      color: #000;
      .left_prev {
        position: absolute;
        left: 0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 43% center;
        background-image: url("../../static/images/icon/left_prev.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_prev:hover {
        background-color: #00000080;
      }
      .left_next {
        position: absolute;
        right: 0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 57% center;
        background-image: url("../../static/images/icon/left_next.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_next:hover {
        background-color: #00000080;
      }
      .qualifications_ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .img_box {
          width: 1.275rem;
          height: 1.6063rem;
          background-color: pink;
          margin: 0.1042rem 0rem;
        }
      }
    }
  }
  .cooperation {
    .title_box {
      color: #000;
      margin-top: 0.4948rem;
    }
    .cooperation_box {
      padding: 0px 1.875rem;
      .hezuohuoban_bg {
        height: 3.5833rem;
      }
    }
    .partner_ul_box {
      margin-bottom: 0.63rem;
      display: flex;
      justify-content: space-between;
      .width220 {
        width: 1.2458rem !important;
        transition: 0.3s;
        .img_box {
          width: 1.1458rem !important;
          height: 0.3208rem !important;
          margin: 0 auto;
          transition: 0.3s;
        }
      }
      .width220:hover {
        .img_box {
          width: 1.2458rem !important;
          height: 0.3708rem !important;
        }
      }
      .partner_li {
        width: 0.5208rem;
        cursor: pointer;
        position: relative;
        .img_box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 0.4208rem;
          height: 0.4208rem;
          margin: 0 auto;
          transition: 0.3s;
        }
        p {
          font-size: 0.0842rem;
          font-family: MicrosoftYaHei;
          line-height: 0.1563rem;
          color: #000000;
          opacity: 1;
          padding-top: 0.6304rem;
          transition: 0.3s;
        }
      }
      .partner_li:hover {
        .img_box {
          width: 0.5008rem;
          height: 0.5008rem;
          box-shadow: 0 0 0.0921rem 0px #00000050;
        }
        p {
          font-size: 0.0942rem;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>